import { useEffect } from 'react'

/**
 * Like componentWillUnmount
 */
export function useWillUnmount(fn: () => void) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fn, [])
}
